$('.keyboard').keyboard({
    layout: 'custom',
    customLayout: {
        'normal': [
            '1 2 3 4 5 6 7 8 9 0 {bksp}',
            'Q W E R T Y U I O P',
            'A S D F G H J K L Ñ',
            'Z X C V B N M',
            '{accept} {space}'
        ],
        // 'normal': [
        //     '` 1 2 3 4 5 6 7 8 9 0 - = {bksp}',
        //     '{tab} q w e r t y u i o p [ ] \\',
        //     'a s d f g h j k l ; \' {enter}',
        //     '{shift} z x c v b n m , . / {shift}',
        //     '{accept} {space} {left} {right} {sp:.2} {del} {combo} {toggle} {extender}'
        // ],
        // 'shift': [
        //     '~ ! @ # $ % ^ & * ( ) _ + {bksp}',
        //     '{tab} Q W E R T Y U I O P { } |',
        //     'A S D F G H J K L : " {enter}',
        //     '{shift} Z X C V B N M < > ? {shift}',
        //     '{accept} {space} {left} {right} {sp:.2} {del} {combo} {toggle} {extender}'
        // ]
    },
    usePreview: false,
    acceptValid: true,
    validate: function(kb, val) {
        return val.length >= 6;
    },
    display : {
        // \u2714 = check mark - same action as accept
        'accept': 'Ok:Ok',
        'bksp':'< '+Lang.get('msg.delete')  
    }
});
// activate the typing extension
//     .addTyping({
//         showTyping: true,
//         delay: 250
//     })
//     .addExtender({
//         layout: 'numpad',
//         showing: false,
//         reposition: true
//     });